/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::01785c0880adede3efdaeb96ca49a40e>>
 * @codegenCommand yarn build:icon-glyphs
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _baseNew = _interopRequireDefault(require("@atlaskit/icon/base-new"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * Icon: "BeachUmbrella".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: User-selectable icon choice for calendars
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */
const BeachUmbrellaIcon = props => /*#__PURE__*/_react.default.createElement(_baseNew.default, Object.assign({
  name: "BeachUmbrellaIcon",
  dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 15H1v-1.5h14z" clip-rule="evenodd"/><path fill="currentcolor" fill-rule="evenodd" d="m3.656 4.126 1.714.99a9.2 9.2 0 0 1 3.54-3.042 5.5 5.5 0 0 0-5.254 2.052M10.598 3c-.307.1-.7.252-1.135.474a7.7 7.7 0 0 0-2.789 2.393l3.402 1.965c.61-1.34.729-2.62.678-3.613A8 8 0 0 0 10.598 3m.782 5.585 1.714.99a5.5 5.5 0 0 0-.85-5.577l.008.145a9.2 9.2 0 0 1-.872 4.442M1.938 4a7 7 0 1 1 12.124 7 .75.75 0 0 1-1.024.275l-4.763-2.75-3.75 6.495-1.3-.75 3.75-6.495-4.763-2.75A.75.75 0 0 1 1.938 4" clip-rule="evenodd"/>`
  // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
}, props));
BeachUmbrellaIcon.displayName = 'BeachUmbrellaIcon';
var _default = exports.default = BeachUmbrellaIcon;